/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shopping_Have_ItInputs */

const en_shopping_have_it = /** @type {(inputs: Shopping_Have_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Have it`)
};

const de_shopping_have_it = /** @type {(inputs: Shopping_Have_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hab ich`)
};

/**
* | output |
* | --- |
* | "Have it" |
*
* @param {Shopping_Have_ItInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_have_it = /** @type {((inputs?: Shopping_Have_ItInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_Have_ItInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_have_it(inputs)
	return en_shopping_have_it(inputs)
});